/*
 * 对话页的交互数据持续化存储
 * */

import { getMarkKey } from '@/utils';
import { getLocal, setLocal } from '@meiqia/utils/storage';

const listTypeLocalKey = 'convListType';
export const getLocalListType = () => {
  const convListType = getLocal(listTypeLocalKey) || {};
  let tempData = '';
  if (convListType) {
    tempData = convListType[getMarkKey()] || '';
  }
  return tempData;
};

export const setLocalListType = result => {
  let tempData = getLocal(listTypeLocalKey);
  if (!tempData) {
    setLocal(listTypeLocalKey, {});
    tempData = getLocal(listTypeLocalKey);
  }
  tempData[getMarkKey()] = result;

  setLocal(listTypeLocalKey, tempData);
};

const checkedAgentLocalKey = 'checkedAgent';
export const getLocalCheckedAgent = () => {
  const checkedAgent = getLocal(checkedAgentLocalKey) || {};
  let tempData = [];
  if (checkedAgent) {
    tempData = checkedAgent[getMarkKey()] || [];
  }
  return tempData;
};

export const setLocalCheckedAgent = result => {
  let tempData = getLocal(checkedAgentLocalKey);
  if (!tempData) {
    setLocal(checkedAgentLocalKey, {});
    tempData = getLocal(checkedAgentLocalKey);
  }
  tempData[getMarkKey()] = result;

  setLocal(checkedAgentLocalKey, tempData);
};

const quickReplyExpandKey = 'quickReplyExpand';
export const getLocalQuickReplyExpand = () => {
  const convListType = getLocal(quickReplyExpandKey) || {};
  let tempData = {};
  if (convListType) {
    tempData = convListType[getMarkKey()] || {};
  }
  return tempData;
};

export const setLocalQuickReplyExpand = result => {
  let tempData = getLocal(quickReplyExpandKey);
  if (!tempData) {
    setLocal(quickReplyExpandKey, {});
    tempData = getLocal(quickReplyExpandKey);
  }
  tempData[getMarkKey()] = result;

  setLocal(quickReplyExpandKey, tempData);
};
